import React, { ReactNode } from 'react';
import { Field } from 'react-final-form';
import styled from 'styled-components';

import { InputProps, Switch } from '@xsolla/ui-core';

type Props = InputProps & {
  label?: ReactNode | string;
  name: string;
  caption?: ReactNode | string;
};

const FieldSwitchWrapper = styled.div`
  margin-bottom: 24px;
`;

const FieldSwitch = ({ label, name, caption, ...props }: Props): JSX.Element => {
  return (
    <FieldSwitchWrapper>
      <Field name={name} type="checkbox">
        {({ input }) => (
          <Switch caption={caption} {...props} {...input}>
            {label}
          </Switch>
        )}
      </Field>
    </FieldSwitchWrapper>
  );
};

export default FieldSwitch;
